import symbolName from "@/util/symbol-name.mjs";

export const GAME_SYMBOL_ROCKETLEAGUE: unique symbol =
  symbolName("rocketleague");
